import React from 'react';

function PageBreak() {
  return (
    <div style={{
      pageBreakAfter: 'always',
      breakAfter: 'always',
    }}>
      {' '}
    </div>
  );
}

export default PageBreak;
